import { Component, OnInit } from '@angular/core';
import { BlogService } from './blog.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-blogs',
    templateUrl: './blogs.component.html',
    styleUrls: ['./blogs.component.css'],
    standalone: false
})
export class BlogsComponent implements OnInit {
  blogs: any[] = [];
  featuredBlog: any;
  sideBlogs: any[] = [];
  otherBlogs: any[] = [];

  constructor(private blogService: BlogService, private router: Router) {}

  ngOnInit(): void {
    this.getBlogs();
  }

  openBlog(blog: any): void {
  if (!blog || !blog.slug) {
    console.warn('Blog slug missing, falling back to ID');
    this.router.navigate(['/blogs', blog.id]);
    return;
  }
  this.router.navigate(['/blogs', blog.slug]);
}

  getBlogs(): void {
    this.blogService.getAllBlogs().subscribe(
      (response) => {
        if (response.message === 'Blogs retrieved successfully!') {
          this.blogs = response.data.reverse(); // latest first
          this.arrangeBlogs();
        } else {
          this.blogs = [];
          alert('Failed to fetch blogs: ' + response.message);
        }
      },
      (error) => {
        console.error("Error fetching blogs:", error);
        alert('An error occurred while fetching blogs.');
      }
    );
  }

  arrangeBlogs(): void {
    this.featuredBlog = this.blogs[0];
    this.sideBlogs = this.blogs.slice(1, 4);
    this.otherBlogs = this.blogs.slice(4);
  }

  scrollToBlogs() {
    const calendarElement = document.getElementById("calendar-section");
    if (calendarElement) {
      calendarElement.scrollIntoView({ behavior: "smooth" });
    }
  }
}